import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Custom hook to ensure document direction is always set correctly for RTL languages
 * This hook runs on mount and when the language changes
 */
export function useDocumentDirection() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const updateDirection = () => {
      const isRTL = i18n.language === 'fa';
      document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
      document.documentElement.lang = i18n.language;
    };

    // Set direction immediately
    updateDirection();

    // Listen for language changes
    i18n.on('languageChanged', updateDirection);

    // Cleanup
    return () => {
      i18n.off('languageChanged', updateDirection);
    };
  }, [i18n]);
}
